<template>
  <div>

    <v-layout wrap align-center>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando">
          <label>Tipo Credenciamento</label>
          <p>{{ getTipoCredenciamento(value.tipoCredenciamento) }}</p>
        </div>
        <az-combo-enum-licitacao name="Tipo Credenciamento" label="Tipo Credenciamento" placeholder="Selecione"
                                 v-else v-model="value.tipoCredenciamento" is-required
                                 class="required-field"
                                 :disabled="visualizando"
                                 :enum-object="tiposCredenciamento" @input="configurarCamposAmparoModalidade"
                                 :error-messages="errors.collect('Modalidade')"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando">
          <label>Amparo Legal</label>
          <p>{{ getAmparoLegal }}</p>
        </div>
        <v-select v-else
                  name="Amparo Legal" label="Amparo Legal" placeholder="Selecione"
                  key="AmparoLegal" :return-object="true"
                  class="required-field" v-validate="'required'"
                  :disabled="value.publicado || value.origem === 'EXTERNA'"
                  :loading="amparoLegalLoading"
                  :menu-props="{ top: false, offsetY: true }"
                  v-model="value.amparoLegal"
                  :items="amparosLegais"
                  item-text="lei" item-value="id" :error-messages="errors.collect('Amparo Legal')"
                  @change="configurarAmparoLegalModalidade"
        />
      </v-flex>

      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="possuiApenasUmOrgao || value.publicado || visualizando">
          <label v-if="this.value.ehPerfilComprasBR">Órgão</label>
          <label v-else>Responsável</label>
          <p>{{ orgaoUsuarioDescricao }}</p>
        </div>
        <v-select name="Responsável" :label="labelResponsavel" placeholder="Selecione"
                  :disabled="value.publicado || value.origem === 'EXTERNA'"
                  class="required-field" v-validate="'required'"
                  :menu-props="{ top: false, offsetY: true}"
                  v-model="value.idOrgao"
                  :error-messages="errors.collect('Responsável')"
                  :items="orgaosUsuario"
                  v-else
        >
        </v-select>
      </v-flex>

      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-limite-esclarecimento-impugnacao" v-if="visualizando || value.publicado">
          <label>Data/Hora Limite Esclarecimento/Impugnação</label>
          <p>{{ value.dataLimiteEsclarecimentoImpugnacao | az-date('DD/MM/YYYY HH:mm:ss') }}</p>
        </div>
        <az-date-licitacao v-else
                           :disabled="value.publicado"
                           date-time
                           v-model="value.dataLimiteEsclarecimentoImpugnacao"
                           label="Data/Hora Limite Esclarecimento/Impugnação"
                           name-date="Data Limite Esclarecimento/Impugnação"
                           name-hour="Hora Limite Esclarecimento/Impugnação"
                           :enableSeconds="true"
        ></az-date-licitacao>
      </v-flex>

      <v-flex xs12 sm4 d-flex v-if="exibirDataHoraAberturaCredenciamento">
        <div class="az-text licitacao-abertura" v-if="visualizando || value.publicado">
          <label>Data/Hora de Abertura</label>
          <p>{{ value.dataAbertura | az-date('DD/MM/YYYY HH:mm:ss') }}</p>
        </div>
        <az-date-licitacao v-else
                           :disabled="value.publicado"
                           date-time
                           v-model="value.dataAbertura"
                           label="Data/Hora de Abertura"
                           name-date="Data/Hora de Abertura"
                           name-hour="Data/Hora de Abertura"
                           :enableSeconds="true"
        ></az-date-licitacao>
      </v-flex>

      <v-flex xs12 sm4 d-flex>
        <div class="credenciamento-data-fim" v-if="visualizando || value.publicado">
          <div class="az-text licitacao-limite-esclarecimento-impugnacao credenciamento-data-fim__conteudo"
               v-if="!editandoDataFimCredenciamento">
            <label>Data/Hora Fim Credenciamento</label>
            <p>{{ value.dataFimEnvioProposta | az-date('DD/MM/YYYY HH:mm:ss') }}</p>
          </div>
          <az-date-licitacao v-else
                             date-time
                             class="required-field credenciamento-data-fim__conteudo"
                             v-model="dataFimCredenciamentoEmEdicao"
                             is-required
                             label="Data/Hora Fim Credenciamento"
                             name-date="Nova Data Fim Credenciamento"
                             name-hour="Nova Hora Fim Credenciamento"
                             :enableSeconds="true"
          ></az-date-licitacao>

          <v-tooltip bottom class="credenciamento-data-fim__acao acao-editar-data-fim-credenciamento"
                     v-if="permiteAlterarDataFimCredenciamento && !editandoDataFimCredenciamento">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon flat small @click="habilitarEdicaoDataFimCredenciamento">
                <v-icon size="18">edit</v-icon>
              </v-btn>
            </template>
            <span>Alterar a Data/Hora Fim Credenciamento</span>
          </v-tooltip>

          <v-tooltip bottom class="credenciamento-data-fim__acao acao-salvar-data-fim-credenciamento"
                     v-if="permiteAlterarDataFimCredenciamento && editandoDataFimCredenciamento">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon flat small @click="salvarDataFimCredenciamento">
                <v-icon size="18">save</v-icon>
              </v-btn>
            </template>
            <span>Salvar a nova Data/Hora Fim Credenciamento</span>
          </v-tooltip>

          <v-tooltip bottom class="credenciamento-data-fim__acao acao-cancelar-data-fim-credenciamento"
                     v-if="permiteAlterarDataFimCredenciamento && editandoDataFimCredenciamento">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon flat small @click="cancelarEdicaoDataFimCredenciamento">
                <v-icon size="18">close</v-icon>
              </v-btn>
            </template>
            <span>Cancelar a alteração da Data/Hora Fim Credenciamento</span>
          </v-tooltip>
        </div>
        <az-date-licitacao v-else
                           :disabled="value.publicado"
                           date-time
                           class="required-field"
                           v-model="value.dataFimEnvioProposta"
                           is-required
                           label="Data/Hora Fim Credenciamento"
                           name-date="Data Fim Credenciamento"
                           name-hour="Hora Fim Credenciamento"
                           :enableSeconds="true"
        ></az-date-licitacao>
      </v-flex>


      <v-flex xs12 sm12 d-flex>
        <div class="az-text" v-if="visualizando">
          <label>Objeto</label>
          <p>{{ value.objeto }}</p>
        </div>
        <div v-else>
          <v-textarea name="Objeto" label="Objeto" v-model="value.objeto"
                      placeholder="Ex. Compra de Material de Expediente"
                      required :readonly="visualizando"
                      :disabled="value.publicado || value.origem === 'EXTERNA'"
                      :maxlength="5000" class="required-field"
                      v-validate="{rules: {required:true, max:5000}}"
                      :error-messages="errors.collect('Objeto')"
          ></v-textarea>
          <p class="az-text" style="float: right">
            {{ 5000 - (value.objeto ? value.objeto.length : 0) }}
          </p>
        </div>
      </v-flex>

      <v-flex xs12 sm12 d-flex>
        <div class="az-text" v-if="visualizando || value.publicado">
          <label>Informação Complementar</label>
          <p>{{ value.informacaoComplementar || '--' }}</p>
        </div>
        <div v-else>
          <v-textarea name="Informação Complementar" label="Informação Complementar"
                      v-model="value.informacaoComplementar"
                      placeholder="Ex. Informação Complementar"
                      :readonly="visualizando"
                      rows="1"
                      :maxlength="500"
                      v-validate="{rules: {max:500}}"
                      :error-messages="errors.collect('Informação Complementar')"
          ></v-textarea>
          <p class="az-text" style="float: right">
            {{ 500 - (value.informacaoComplementar ? value.informacaoComplementar.length : 0) }}
          </p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  actionTypes,
  formatosDefault,
  modalidadesLicitacao,
  modoDisputa,
  opcaoSimNao,
  tiposDisputa,
  tiposLicitacao,
  tiposLicitacaoSemMaiorOferta,
  tiposLicitacaoComTecnicaPreco,
  legislacao,
  tipoObjeto,
  origemRecurso,
  tipoTransferencia,
  tiposCredenciamento
} from '@/commons/constants'
import AzComboEnumLicitacao from '@/commons/components/AzComboEnumLicitacao.vue'
import AzDateLicitacao from '@/commons/components/AzDateLicitacao.vue'
import validadorDatas from '@/views/credenciamento/detalhe-credenciamento/orgao/credenciamento-atualizacao-validador-datas'
import { mapState } from 'vuex'

export default {
  name: 'DadosGerais',
  components: {AzComboEnumLicitacao, AzDateLicitacao},
  inject: ['$validator'],
  props: {
    acao: {
      type: String,
      validator: val => ['inserindo', 'editando', 'visualizando'].includes(val),
      default: 'visualizando'
    },
    value: {
      required: true
    },
    exibirAno: {
      type: Boolean
    }
  },
  data() {
    return {
      editandoDataFimCredenciamento: false,
      dataFimCredenciamentoEmEdicao: null,
      comissoes: [],
      orgaosUsuario: [],
      casasDecimais: [],
      casasDecimaisQuantidade: [],
      formatoData: formatosDefault.DATA_HORA,
      modalidadesLicitacao,
      tiposCredenciamento,
      modoDisputa,
      opcaoSimNao,
      tiposDisputa,
      tiposLicitacao,
      legislacao,
      tipoObjeto,
      origemRecurso,
      tipoTransferencia,
      tipoLances: [
        {
          text: 'Valor (R$)',
          value: false
        },
        {
          text: 'Percentual (%)',
          value: true
        }
      ],
      beneficioLocal: {
        ativado: false,
        municipiosUf: [],
        cidadeSelecionada: []
      },
      ufs: [],
      orgaoUsuario: null,
      modoDisputaPregao: [
        {text: 'Aberto', value: 'ABERTO', disabled: false},
        {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
        {text: 'Randômico', value: 'RANDOMICO', disabled: false},
        {text: 'Fechado', value: 'FECHADO', disabled: false}
      ],
      modoDisputaAmparoLegal: [
        {
          codigoAmparoLegal: '0', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: true},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: true},
            {text: 'Randômico', value: 'RANDOMICO', disabled: false},
            {text: 'Fechado', value: 'FECHADO', disabled: true}
          ],
          modoDisputa: 'RANDOMICO',
          bloquearInversaoDeFases: true
        },
        {
          codigoAmparoLegal: '-1', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: true},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: true},
            {text: 'Randômico', value: 'RANDOMICO', disabled: false},
            {text: 'Fechado', value: 'FECHADO', disabled: true}
          ],
          modoDisputa: 'RANDOMICO',
          bloquearInversaoDeFases: true
        },
        {
          codigoAmparoLegal: '-3', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: true
        },
        {
          codigoAmparoLegal: '1', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '2', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '-2', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '-4', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        }
      ],
      bloquearInversaoDeFases: false,
      amparosLegais: [],
      amparoLegalLoading: false
    }
  },
  computed: {
    ...mapState(['parametros']),
    permiteAlterarDataFimCredenciamento() {
      return !this.visualizando && Boolean(this.value.publicado) && this.value.status === 'ABERTO'
    },
    exibirDataHoraAberturaCredenciamento() {
      const props = this.parametros && this.parametros.propriedadesLicitacao;
      const v = props ? props.exibirDataHoraAberturaCredenciamento : undefined;
      return v === undefined || v === null ? false : v;
    },
    todosMunicipiosSelecionados() {
      return this.beneficioLocal.cidadeSelecionada.length === this.beneficioLocal.municipiosUf.length
    },
    comissaoDescricao() {
      let comissaoDescricao = ''
      this.comissoes.forEach(comissao => {
        if (comissao.value === this.value.idComissaoApuracao) {
          comissaoDescricao = comissao.text
        }
      })
      return comissaoDescricao
    },
    orgaoUsuarioDescricao() {
      if (this.value.nomeOrgao)
        return `${this.value.nomeOrgao} - ${this.value.siglaOrgao}`
      if (this.possuiApenasUmOrgao && this.orgaosUsuario.length > 0) {
        let index = this.orgaosUsuario.map(orgao => orgao.value).indexOf(this.value.idOrgao)
        return this.orgaosUsuario[index].text
      }
    },
    pregoeiro() {
      let pregoeiro = ''
      this.comissoes.forEach(comissao => {
        if (comissao.value === this.value.idComissaoApuracao) {
          pregoeiro = comissao.pregoeiro
        }
      })
      return pregoeiro
    },
    visualizando() {
      return this.acao === 'visualizando'
    },
    getAmparoLegal() {
      if (this.value.amparoLegal) {
        return this.value.amparoLegal.lei
      }
      return '---'
    },
    labelResponsavel() {
      if (this.value.ehPerfilComprasBR) {
        return 'Órgão'
      } else {
        return 'Responsável'
      }
    },
    possuiApenasUmOrgao() {
      return this.orgaosUsuario.length === 1 || this.value.ehPerfilComprasBR
    },
    ehAmparoLei14133Art82() {
      if (this.value && this.value.amparoLegal)
        return this.value.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
    },
    ehModalidadeConcorrencia() {
      return this.value.modalidade === 'CONCORRÊNCIA ELETRÔNICA'
    },
    getTipoLicitacao() {
      const {amparoLegal} = this.value;
      if (this.ehModalidadeConcorrencia && this.temAmparoLei14133Incluso(amparoLegal)) {
        return tiposLicitacaoComTecnicaPreco
      }
      if (this.temAmparoLei14133Incluso(amparoLegal)) {
        return tiposLicitacaoSemMaiorOferta;
      }
      return tiposLicitacao;
    }
  },
  watch: {
    orgaosUsuario: {
      handler() {
        if (this.possuiApenasUmOrgao && this.orgaosUsuario[0]) {
          this.value.idOrgao = this.value.idOrgao ? this.value.idOrgao : this.$store.state.loki.user.domainId
        }
      },
      deep: false
    },
    'value.dataAbertura': {
      handler(novoValor) {
        this.value.dataIniEnvioProposta = novoValor
      },
      immediate: true
    }
  },
  async mounted() {
    await this.buscarAmparoLegal();
    this.comissoes = await this.buscarComissoesApuracao()
    this.ufs = await this.buscarUFs()
    this.orgaoUsuario = await this.buscarOrgaoUsuario();
    this.orgaosUsuario = await this.buscarOrgaosUsuario();
    this.casasDecimais = [
      {text: '2', value: 2},
      {text: '3', value: 3},
      {text: '4', value: 4}
    ];
    this.casasDecimaisQuantidade = [
      {text: '0', value: 0},
      {text: '2', value: 2},
      {text: '3', value: 3},
      {text: '4', value: 4}
    ];
    this.beneficioLocal.ativado = this.value.beneficiosRegionais && this.value.beneficiosRegionais.length > 0;
    this.configurarAmparoLegalModalidade()
    this.configurarListaAmparoLegal(false)
    this.limparAmparoLegalIncompativel()
  },
  methods: {
    habilitarEdicaoDataFimCredenciamento() {
      this.dataFimCredenciamentoEmEdicao = this.value.dataFimEnvioProposta
      this.editandoDataFimCredenciamento = true
    },
    cancelarEdicaoDataFimCredenciamento() {
      this.editandoDataFimCredenciamento = false
      this.dataFimCredenciamentoEmEdicao = null
    },
    async salvarDataFimCredenciamento() {
      const validacao = validadorDatas.validarAlteracaoDataFim(this.value, this.dataFimCredenciamentoEmEdicao)
      if (!validacao.valido) {
        this.mostrarNotificacaoErro(validacao.mensagem)
        return
      }

      try {
        this.setMensagemLoading('Alterando a Data/Hora Fim Credenciamento...')
        await this.$store.dispatch(actionTypes.CREDENCIAMENTO.ALTERAR_DATA_FIM_CREDENCIAMENTO, {
          credenciamentoId: this.value.id,
          dataFimCredenciamento: this.dataFimCredenciamentoEmEdicao
        })
        this.value.dataFimEnvioProposta = this.dataFimCredenciamentoEmEdicao
        this.editandoDataFimCredenciamento = false
        await this.$store.dispatch(actionTypes.BUSCAR_LICITACAO, this.value.id)
        this.mostrarNotificacaoSucesso('Data/Hora Fim Credenciamento alterada com sucesso.')
      } catch (erro) {
        this.mostrarNotificacaoErro(this.obterMensagemErroAlteracaoDataFim(erro))
      }
    },
    obterMensagemErroAlteracaoDataFim(erro) {
      const dadosErro = erro && erro.response && erro.response.data
      const mensagemApi = dadosErro && (dadosErro.message || dadosErro.detail)
      return mensagemApi || 'Não foi possível alterar a Data/Hora Fim Credenciamento.'
    },
    limparAmparoLegalIncompativel() {
      if (this.value.amparoLegal) {
        if (!this.amparosLegais.map(amparo => amparo.id).includes(this.value.amparoLegal.id)) {
          this.value.amparoLegal = null
        }
      }
    },
    ehPerfilFornecedor() {
      return this.$store.state.loki.user.type === 'EXTERNO'
    },
    async buscarAmparoLegal() {
      this.amparoLegalLoading = true
      const dados = await this.$store.dispatch(actionTypes.BUSCAR_AMPARO_LEGAL_SITUACAO, 'ATIVO')
      if (dados) {
        this.amparosLegais = dados
      }
      this.amparoLegalLoading = false
    },
    async buscarComissoesApuracao() {
      const comissoes = await this.$store.dispatch(actionTypes.BUSCAR_COMISSOES_APURACAO)
      const listaComissoes = []
      comissoes.forEach(comissao => {
        listaComissoes.push({text: comissao.sigla, value: comissao.id, pregoeiro: comissao.presidente.nome})
      })
      return listaComissoes
    },
    async buscarOrgaoUsuario() {
      if (this.ehPerfilFornecedor()) {
        return
      }
      const uo = await this.$store.dispatch(actionTypes.BUSCAR_ORGAO, {orgaoId: this.$store.state.loki.user.domainId});
      if (!uo) {
        return null
      }
      this.beneficioLocal.ufSelecionada = uo.unidadeOrganizacional.municipio.estado.id;
      await this.buscarMunicipios();
      return uo.unidadeOrganizacional;
    },
    async buscarOrgaosUsuario() {
      const uosUsuario = await this.$store.dispatch(actionTypes.BUSCAR_ORGAOS_USUARIO)
      const orgaos = uosUsuario.orgaos
      let listaUosUsuario = []
      orgaos.forEach(uo => {
        if (uo.id === this.$store.state.loki.user.domainId) {
          this.value.idOrgao = this.value.idOrgao ? this.value.idOrgao : uo.id
        }
        listaUosUsuario.push({text: `${uo.nome} - ${uo.sigla}`, value: uo.id})
      })
      return listaUosUsuario
    },
    async buscarUFs() {
      return await this.$store.dispatch(actionTypes.BUSCAR_UFS);
    },
    async buscarMunicipios() {
      if (!this.beneficioLocal.ufSelecionada) {
        return;
      }
      const data = await this.$store.dispatch(actionTypes.BUSCAR_MUNICIPIOS, {ufId: this.beneficioLocal.ufSelecionada});
      this.$set(this.beneficioLocal, 'municipiosUf', data)
    },
    async configurarCamposAmparoModalidade() {
      await this.buscarAmparoLegal();
      this.configurarListaAmparoLegal(true)
      this.configurarAmparoLegalModalidade()
      this.setarModoDisputaFechado()
    },
    configurarListaAmparoLegal(limparCampos) {
      if (this.value.modalidade === 'CONCORRÊNCIA ELETRÔNICA') {
        const amparoLegal = this.amparosLegais.find(item => item.codigo === '2')
        this.amparosLegais = [amparoLegal]
        this.value.amparoLegal = amparoLegal
        this.value.idAmparoLegal = amparoLegal.id
      } else if (this.value.modalidade === 'PREGÃO ELETRÔNICO') {
        this.amparosLegais = this.amparosLegais.filter(item => item.codigo !== '2')
        if (limparCampos) {
          this.value.amparoLegal = null
          this.value.idAmparoLegal = null
        }
      }
    },
    configurarAmparoLegalModalidade() {
      if (!this.visualizando && this.value.amparoLegal) {
        this.value.idAmparoLegal = this.value.amparoLegal.id
        const modoDisputaSelecao = this.modoDisputaAmparoLegal.find(item => item.codigoAmparoLegal === this.value.amparoLegal.codigo)
        if (modoDisputaSelecao) {
          this.modoDisputaPregao = modoDisputaSelecao.modoDisputaAmparo
          if (this.value.modoDisputa === 'RANDOMICO' && modoDisputaSelecao.modoDisputa == null) {
            this.value.modoDisputa = modoDisputaSelecao.modoDisputa
          } else if (this.value.modoDisputa !== 'RANDOMICO' && modoDisputaSelecao.modoDisputa) {
            this.value.modoDisputa = modoDisputaSelecao.modoDisputa
          }
          this.bloquearInversaoDeFases = modoDisputaSelecao.bloquearInversaoDeFases
          if (this.bloquearInversaoDeFases) {
            this.value.inversaoFases = false
          }
          if (this.ehAmparoLei14133Art82) {
            this.value.tipoDisputa = 'VALOR_UNITARIO'
          }
        }
      }
    },
    setarModoDisputaFechado() {
      if (this.value.modalidade === 'CONCORRÊNCIA ELETRÔNICA') {
        this.value.modoDisputa = this.value.tipoLicitacao === 'TP' ? 'FECHADO' : null;
        this.modoDisputaPregao.forEach(modo => {
          switch (modo.value) {
            case 'ABERTO_FECHADO':
            case 'ABERTO':
              modo.disabled = this.value.tipoLicitacao === 'TP';
              break;
            case 'FECHADO':
              modo.disabled = this.value.tipoLicitacao !== 'TP';
              break;
          }
        });
        return;
      }
      this.value.modoDisputa = null;
    },
    buscarMunicipioPorId(municipioId) {
      if (!this.beneficioLocal.municipiosUf || this.beneficioLocal.municipiosUf.length === 0) {
        return null;
      }
      let municipio = this.beneficioLocal.municipiosUf.find(item => item.id === municipioId);

      const municipioDTO = {
        estado: municipio.estado,
        id: municipio.id,
        idIntegracao: municipio.idIntegracao,
        nome: municipio.nome
      }
      return municipioDTO;
    },
    buscarUfPorId(ufId) {
      if (!this.ufs || this.ufs.length === 0) {
        return null;
      }
      let uf = null;
      this.ufs.some(item => {
        if (item.id === ufId) {
          uf = item;
          return true;
        }
        return false;
      });
      return uf;
    },
    getModoDisputa(modo) {
      return this.modoDisputa[modo]
    },
    getDisputa(disputa) {
      return this.tiposDisputa[disputa]
    },
    getTipoObjeto(tipoObj) {
      return this.tipoObjeto[tipoObj]
    },
    getLegislacao(legi) {
      return this.legislacao[legi]
    },
    getOrigemRecurso(origRec) {
      return this.origemRecurso[origRec]
    },
    getTipoTransferencia(tpTransf) {
      return this.tipoTransferencia[tpTransf]
    },
    getTipoCredenciamento(tipo) {
      return this.tiposCredenciamento[tipo]
    },
    anularAtributosRecursoFederal() {
      if (this.value.recursoFederal === false) {
        this.value.tipoTransferencia = null
        this.value.origemRecurso = null
        this.value.numeroConvenio = null
        this.value.numeroCompra = null
        this.value.anoInstrumento = null
        this.value.tipoObjeto = null
        this.value.legislacao = null
      }
    },
    getCidade(ufSigla, cidadeId) {
      if (!cidadeId || !ufSigla) {
        return null;
      }
      const parsedData = JSON.parse(JSON.stringify(this.$data));
      const cidades = parsedData.cidadesUf[ufSigla];
      if (!cidades) {
        return null;
      }
      let cidade = null;
      cidades.forEach(item => {
        if (item.idMunicipio === cidadeId) {
          cidade = item;
        }
      });
      return cidade;
    },
    getUf(id) {
      if (id > 26) {
        return null;
      }
      const parsedData = JSON.parse(JSON.stringify(this.$data));
      return parsedData.ufs[id - 1]; // Array inicia com zero, UF posição 0 até UF posição 26.
    },
    async ativarBeneficioRegional() {
      this.$set(this.value, 'beneficiosRegionais', []);
      this.beneficioLocal.ufSelecionada = this.orgaoUsuario.municipio.estado.id;
      await this.buscarMunicipios();
      if (this.beneficioLocal.ativado) {
        this.value.beneficiosRegionais.push({
          estado: this.buscarUfPorId(this.orgaoUsuario.municipio.estado.id),
          municipio: this.buscarMunicipioPorId(this.orgaoUsuario.municipio.id),
          beneficioLocal: true
        });
      } else {
        this.value.beneficioRegional = false
        this.value.regimento = null
      }
    },
    temAmparoLei14133Incluso(amparoLegal) {
      return amparoLegal && /^Lei 14\.133\/2021, Art\. \d+,/.test(amparoLegal.lei);
    }
  },
  filters: {
    opcaoSimNaoFilter(valor) {
      return opcaoSimNao[valor]
    }
  }
}
</script>
<style lang="stylus">

  .municipio-beneficio
    width 250px

  .selecionar-todos-municipios-btn
    display flex
    flex-direction row
    font-size 14px
    font-weight bold
    color #77797B

  .checkbox-beneficio-posicao
    display flex
    align-self center

  .separadorBeneficioLocal
    margin-left 25px
    padding-left 5px
    display flex
    flex-direction row
    align-items center

  .regimento-beneficio
    display flex
    flex-direction row
    align-items center

  .regimento-label
    margin-bottom 0px
    margin-right 5px

  //.az-date #iddiv span.myclass
  .beneficio-local-card
    border solid #c5c5c5 1px !important

  .beneficio-local-toolbar
    border solid #c5c5c5 1px !important
    border-left 0 !important
    border-top 0 !important
    border-right 0 !important
    padding-bottom 0 !important

  .beneficio-local-toolbar .v-toolbar__content
    padding-left 10px !important

  .beneficio-local-checkbox .v-input__slot
    margin 5px 0px 0px 10px !important

  .beneficio-local-checkbox .v-input--selection-controls__input
    margin-right 0px

  .beneficio-local-checkbox label
    font-size: 12px !important

  .beneficio-local-item
    border solid #c5c5c5 1px
    margin-bottom 10px

  .required-field label:after
    content " *"
    color rgb(255, 98, 98)

  .credenciamento-data-fim
    display flex
    align-items center
    width 100%

  .credenciamento-data-fim__conteudo
    flex 1 1 auto
    min-width 0

  .credenciamento-data-fim__acao
    flex 0 0 auto
    margin 0 0 0 4px

</style>
